import styles from './Notice.module.css';

interface Props {
  kind: 'error' | 'info';
  text: string;
  onDismiss(): void;
}

export function Notice({ kind, text, onDismiss }: Props) {
  return (
    <div className={`${styles.notice} ${styles[kind]}`} role="alert">
      <span>{text}</span>
      <button className={styles.close} onClick={onDismiss} aria-label="Fechar aviso">
        ×
      </button>
    </div>
  );
}
